var exports = {
  "w": "x127c5a35--479550--header",
};

module.exports = exports;
